import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { CockpitUserType } from '../../api/types'
import { withCommitmentPbmUsers } from '../../lib'

import { selectCockpitCommitmentData } from './selectCockpitCommitmentData'
import { selectCockpitOffering } from './selectCockpitOffering'
import { selectCockpitPartnerIdsForSelectedRtm } from './selectCockpitPartnerIdsForSelectedRtm'
import { selectCockpitPendingActionsUsers } from './selectCockpitPendingActionsUsers'

export const selectCockpitPbmUsers = createSelector(
  [
    selectCockpitPendingActionsUsers,
    selectCockpitCommitmentData,
    selectCockpitOffering,
    selectCockpitPartnerIdsForSelectedRtm,
  ],
  (users, commitmentData, selectedOffering, partnerIds) =>
    withCommitmentPbmUsers(users, commitmentData).filter(
      (user) =>
        user.UserType === CockpitUserType.PBM &&
        partnerIds.has(user.PartnerId) &&
        (selectedOffering === ProgramTypes.Overall ||
          selectedOffering === ProgramTypes.Consolidated ||
          user.Offering === selectedOffering)
    )
)
